export const MAX_TEAMS_PER_USER = 10;
export const SHOW_ALL_MEMBERS_LIMIT = 6;

export const MAX_INVITES_AT_ONE_TIME = 10;
